import Vue from 'vue';
import gaService from './ga.service';

export default {
    async openSession(language) {
        gaService.send('games', 'covid', 'covid');
        return (await Vue.http.post('/api/covid/session/open', { language })).data;
    },
    async openDemoSession(language) {
        gaService.send('games-demo', 'covid', 'covid demo');
        return (await Vue.http.post('/api/covid/session/opendemo', { language })).data;
    },
    async closeSession() {
        return (await Vue.http.post('/api/covid/session/close')).data;
    }
};



// WEBPACK FOOTER //
// ./_common/services/covid.service.js